// src/features/wishlistSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import WishlistManager from '../services/dashboard/WishlistManager';

// 1️⃣ Fetch entire wishlist
export const fetchWishlist = createAsyncThunk(
  'wishlist/fetchWishlist',
  async (userId) => {
    const items = await WishlistManager.getWishlistByUser(userId); // Assuming this returns book array
    return items;
  }
);

// 2️⃣ Add a book to wishlist
export const addToWishlistAsync = createAsyncThunk(
  'wishlist/addToWishlistAsync',
  async ({ userId, book }, { dispatch }) => {
    await WishlistManager.addToWishlist(userId, book.id);
    dispatch(addToWishlistLocal(book));
    return book;
  }
);

// 3️⃣ Remove a book from wishlist
export const removeFromWishlistAsync = createAsyncThunk(
  'wishlist/removeFromWishlistAsync',
  async ({ userId, bookId }, { dispatch }) => {
    await WishlistManager.removeFromWishlist(userId, bookId);
    dispatch(removeFromWishlistLocal(bookId));
    return bookId;
  }
);

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState: {
    items: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    addToWishlistLocal: (state, action) => {
      state.items.push(action.payload);
    },
    removeFromWishlistLocal: (state, action) => {
      state.items = state.items.filter(
        (item) => item.book?.bookId !== action.payload
      );
    },
    clearWishlistLocal: (state) => {
      state.items = [];
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWishlist.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchWishlist.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(fetchWishlist.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export const {
  addToWishlistLocal,
  removeFromWishlistLocal,
  clearWishlistLocal,
} = wishlistSlice.actions;

export default wishlistSlice.reducer;
